export default {
    bind($item, $bind, $vue) {
        ['click','touchstart'].forEach( value => {
            const users = $bind.hasOwnProperty('value') ? $bind.value.split('.') : [];

            $item.addEventListener(value, event => {
                if (users.indexOf(window.variables.auth.label) !== -1) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    event.stopPropagation( true );
                    $vue.context.$emit('user-restricted-event', $item.dataset.label);
                }
            }, false);
        });
    }
}
